import { ErrorMessage } from "@hookform/error-message";
import axios from "axios";
import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useMutation } from "react-query";
import { useHistory } from "react-router";
import { PageHeader } from "../../components";
import { useMember } from "../../context/memberContext";
import secureLS from "../../encryption/secureLs";
import routes from "../../routes/routes";

export default function ResetPassword() {
    const history = useHistory()
    const { register, handleSubmit, errors } = useForm();
    const mutation = useMutation(Data => axios.post(routes.api.resetPassword, Data))
    const [message, setMessage] = useState("")
    // const {state,dispatch} = useMember()
    console.log(secureLS.get("member"));
    const onSubmit = async (inputData) => {
        await mutation.mutate(inputData, {
            onSuccess: async (data) => {
                await setMessage(["Successful"])
                console.log(data.data.member);

                // dispatch({type: "storeMember", payload: data.data.member})
                setTimeout(() => {
                    history.push(routes.public.verifyOTP, [data.data.member] )
                }, 3000)
                
              },
              onError: async (error) => {
                  setMessage(["Member Id does not exist"])
                // console.log(error.response.data);
              },
            // onSettled: (data, error, variables, context) => {
            //     // I will fire second!
            //   },
        })
        
    };
    return (
        <>
          <PageHeader title="Reset Password" page="Reset Password" />
            <div className="container" style={{ margin: "200px", marginTop: 20 }}>
                <div className="row">
                    <div className="col-md-7 col-md-offset-1 p-lr40 p-t30 p-b20 clearfix mack-an-appointment black border-1">
                        <div className="card card-body">
                            <h1 className="text-center mb-3">
                                <i className="fas fa-sign-in-alt"></i>
                                Reset password
                            </h1>
                            <p className="text-success">{message[0]}</p>
                            <form onSubmit={handleSubmit(onSubmit)}>
                                <div className="form-group">
                                    <label htmlFor="member_id">Member Id</label>
                                    <input
                                        type="member_id"
                                        id="member_id"
                                        name="member_id"
                                        className="form-control"
                                        placeholder="Enter member_id"
                                        ref={register({
                                            required: "This input is required.",
                                            minLength: {
                                                value: 2,
                                                message: "This input must exceed 2 characters",
                                            },
                                        })}
                                    />
                                    
                                    <ErrorMessage 
                                        errors={errors}
                                        name="member_id"
                                        render={(messages) => {
                                            console.log("messages", messages);
                                            return messages
                                                ? Object.entries(messages).map(([type, message]) => (
                                                    <p className="text-danger" key={type}>{message}</p>
                                                ))
                                                : null;
                                        }}
                                    />
                                </div>
                               
                                <div className="col-md-12 text-center">
                                    <button
                                        name="submit"
                                        type="submit"
                                        className="site-button"
                                        style={{ fontSize: 20, fontWeight: 500 }}
                                    >
                                        Reset
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
